import styled from "styled-components";

import { StyledOperatorFieldRow } from "app/pages/sales-intelligence/common-components/dropdown/styles";

export const StyledDropdownsFlexContainer = styled(StyledOperatorFieldRow)`
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
`;
